<template>
  <section :class="{ 'm-l-20': level > 0 }">
    <div class="columns my-1">
      <div class="column is-10">
        <span class="is-size-5" :class="textClass">{{ lineItem.label }}</span>
      </div>
      <div class="column is-text-align-right" :class="textClass">
        <span v-if="hasValue">{{ formattedValue }}</span>
      </div>
    </div>
    <hr v-if="hasHorizontalLine" />
    <template v-if="lineItem.lineItems">
      <template v-for="(lineItemRow, index) in lineItem.lineItems" :key="index">
        <FinalTaxesLineItemRow :line-item="lineItemRow" :level="level + 1" />
      </template>
    </template>
  </section>
</template>

<script>
import { TaxLineItem } from '@/modules/tax/models/TaxLineItem';
import NumeralService from '@/modules/core/app/services/NumeralService';
import { ColumnFormat } from '@/modules/core/app/constants/data.constants';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FinalTaxesLineItemRow',
  props: {
    lineItem: {
      type: TaxLineItem,
      default: null
    },
    level: {
      type: Number,
      default: 0
    }
  },
  computed: {
    textClass() {
      switch (this.level) {
        case 0:
          return 'has-text-weight-bold';
        case 2:
          return 'has-text-grey';
        default:
          return '';
      }
    },
    hasHorizontalLine() {
      return this.level === 0 && this.lineItem.column.value === null;
    },
    hasValue() {
      return this.lineItem.column.value !== null;
    },
    formattedValue() {
      return NumeralService.formatValue(
        this.lineItem.column.value,
        ColumnFormat.FORMAT_CURRENCY,
        2,
        false,
        '$',
        true,
        true
      );
    }
  }
};
</script>
